<template>
  <div>
    <page1 />
    <section class="accueil-description">
      <h1>Bamboo Sushi – Restaurant japonais à Albi</h1>
      <p>
        Bienvenue chez <strong>Bamboo Sushi</strong>, votre restaurant japonais à Albi. 
        Dégustez nos <strong>sushis faits maison</strong>, makis, brochettes, et spécialités asiatiques à base de produits frais. 
        Sur place ou à emporter, notre équipe vous accueille avec le sourire !
      </p>
      
    </section>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'
import page1 from '@/components/page-1.vue'

useHead({
  title: 'Bamboo Sushi – Restaurant japonais à Albi',
  meta: [
    {
      name: 'description',
      content: 'Restaurant japonais à Albi – Découvrez les sushis faits maison de Bamboo Sushi. Commandez sur place ou à emporter.'
    },
    {
      property: 'og:title',
      content: 'Bamboo Sushi – Sushis faits maison à Albi'
    },
    {
      property: 'og:description',
      content: 'Savourez des sushis préparés avec soin chez Bamboo Sushi à Albi. Sur place ou à emporter.'
    },
    {
      property: 'og:image',
      content: '/images/og-image.jpg'
    },
    {
      property: 'og:url',
      content: 'https://www.bamboosushi.fr/'
    }
  ]
})
</script>

<style scoped>
.accueil-description {
  display: none;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
</style>
